import React from 'react'
import classNames from 'classnames'
import { Stack } from '@hub/stack'
import { SGPageTemplate } from '../../../../src/types/page-templates'
import { Module } from './modules'

export interface ITemplateProps {
  template: SGPageTemplate
  id?: string
}

export function Template({ template, id }: ITemplateProps): JSX.Element {
  const modules = template.modules.flatMap((module, idx) => {
    const args: string[] = ['sc-slot', `sc-slot-${idx}`]
    if (Object.keys(module).includes('analyticsMetadata')) {
      args.push(
        `ad-content-${
          (module as any).analyticsMetadata.displayId.split('/')[3]
        }`
      )
    }
    return (
      <div key={idx} className={classNames(...args)}>
        <Module key={idx} module={module} />
      </div>
    )
  })

  return (
    <>
      {modules.length ? (
        <Stack gap={['spacing-3xl', null, 'spacing-4xl']} id={id}>
          {modules}
        </Stack>
      ) : null}
    </>
  )
}
